export const getListYears = (fromYear, toYear) => {
  let result = [fromYear]
  fromYear++
  while (fromYear <= toYear) {
    result.push(fromYear)
    fromYear++
  }
  return result
}
